<template>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><strong>Routine</strong></h4>
      </div>

      <div class="modal-body">
        Da vocabolario:
        <br />
        Modo, ritmo di vita e di attività che si ripete giorno per giorno,
        sostanzialmente immutato.
        <br />
        <br />
        Lo scopo di questa applicazione è quello di permettere alle persone di
        tener conto del "ritmo di vita" che hanno sviluppato rendendo le
        giornate più organizzate.
      </div>

      <div class="modal-footer d-flex justify-content-center">
        Creato da Leonardo Pellizzon
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "informazioni-app",
};
</script>
  
<style scoped>
</style>
  